import * as React from 'react';
import { connect } from 'react-redux';

import { baseMapDispatchToProps, baseMapStateToProps, ComponentBase, BaseStateProps } from '../componentBase';

import ChangePassword from './changePassword';

export class ChangeMyPassword extends ComponentBase<{}, BaseStateProps> {
  protected loggedInRender(): JSX.Element | string {
    return (
      <div>
        <ChangePassword changeMyPassword userId={this.props.currentUser.id} displayText="Change my password:" />
      </div>
    );
  }
}

export default connect(baseMapStateToProps, baseMapDispatchToProps)(ChangeMyPassword);
